import {gql} from 'apollo-angular';

export const claimKiosk = gql`
  mutation claimKiosk($pin: String!, $owner: String, $role: String){
    response: claimKiosk(pin: $pin, owner: $owner, role: $role){
      _id
    }
  }
`;
